import { render, staticRenderFns } from "./chosseProjectManager.vue?vue&type=template&id=ce8d0bae&scoped=true"
import script from "./chosseProjectManager.vue?vue&type=script&lang=js"
export * from "./chosseProjectManager.vue?vue&type=script&lang=js"
import style0 from "./chosseProjectManager.vue?vue&type=style&index=0&id=ce8d0bae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8d0bae",
  null
  
)

export default component.exports